export default __webpack_public_path__ + "static/media/480_portfolio03-fr-mobile.0e72c24a.png";